var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VLayout',{staticClass:"page"},[_c('VCard',_vm._b({staticClass:"page-card",class:_vm.computedClass},'VCard',_vm.$attrs,false),[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }